/**
 * Fetches movie data from TMDb using an IMDb ID.
 * @param {string} imdbId - The IMDb ID of the movie.
 * @param {string} apiKey - Your TMDb API key.
 * @returns {Promise<object>} - A promise that resolves to the TMDb movie data.
 */
export const fetchMovieByImdbId = async (imdbId, apiKey) => {
  const url = `https://api.themoviedb.org/3/find/${imdbId}?api_key=${apiKey}&external_source=imdb_id`;
    // Example : Mary Queen of Scots
    // - https://www.imdb.com/title/tt2328900/ 
    // - https://api.themoviedb.org/3/find/tt2328900?external_source=imdb_id 

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        `Error fetching movie by IMDb ID: ${response.statusText}`,
      );
    }
    const data = await response.json();

    if (data.movie_results && data.movie_results.length > 0) {
      return data.movie_results[0]; // Return the first movie result
    } else {
      console.error('No movie found for the provided IMDb ID');
      return null;
    }
  } catch (error) {
    console.error('Failed to fetch movie by IMDb ID:', error);
    throw error;
  }
};
